// extracted by mini-css-extract-plugin
module.exports = {"form":"Payment_form__3LEaS","content":"Payment_content__1qxii","active":"Payment_active__2ATgM","feedback":"Payment_feedback__24UQK","error":"Payment_error__15_9U"};